import React from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";

const RevisitHomePage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header title={"Modul Revisit P2TL"} />
      
      <main className="max-w-4xl mx-auto px-6 pt-24 pb-12">
        <div className="mb-10 text-left">
          <h2 className="text-3xl font-extrabold text-slate-900 tracking-tight">
            Modul Revisit P2TL
          </h2>
          <p className="text-sm text-slate-500 mt-2 font-medium">
            Kelola penugasan pemeriksaan ulang P2TL lapangan dan pantau riwayat penugasan.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Card 1: Buat Tugas Baru */}
          <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 flex flex-col justify-between">
            <div>
              <div className="w-12 h-12 rounded-xl bg-indigo-50 flex items-center justify-center text-indigo-600 mb-6">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Buat Tugas Baru</h3>
              <p className="text-sm text-slate-500 leading-relaxed font-medium">
                Daftarkan tugas pemeriksaan ulang P2TL baru dengan menentukan IDPEL pelanggan, unit area posko, batas waktu penyelesaian, dan nomor agenda.
              </p>
            </div>
            <Link
              to="/task"
              className="mt-8 block w-full bg-slate-900 text-white text-center py-2.5 px-4 rounded-xl hover:bg-indigo-600 transition font-semibold text-sm"
            >
              Buat Penugasan
            </Link>
          </div>

          {/* Card 2: Histori Tugas */}
          <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 flex flex-col justify-between">
            <div>
              <div className="w-12 h-12 rounded-xl bg-amber-50 flex items-center justify-center text-amber-600 mb-6">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2">Histori Tugas</h3>
              <p className="text-sm text-slate-500 leading-relaxed font-medium">
                Pantau daftar tugas revisit P2TL yang sudah dibuat, status pengerjaan, dan detail masing-masing pelanggan.
              </p>
            </div>
            <Link
              to="/histori-task"
              className="mt-8 block w-full bg-slate-900 text-white text-center py-2.5 px-4 rounded-xl hover:bg-indigo-600 transition font-semibold text-sm"
            >
              Lihat Histori
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default RevisitHomePage;
